import React from "react";
import "../styles/layout.css";
import "../styles/utilities.css";
import "../styles/forms.css";

const UserTable = ({
  users,
  deactivateUser,
  reactivateUser,
  changeRole,
  resetPassword,
}) => {
  const getStatusBadge = (user) => {
    if (user.is_active === false) {
      return <span className="badge bg-secondary">Desactivado</span>;
    }

    if (user.must_change_password) {
      return (
        <span className="badge bg-warning text-dark">
          Cambio contraseña pendiente
        </span>
      );
    }

    return <span className="badge bg-success">Activo</span>;
  };

  return (
    <div className="table-container">
      <table className="table table-compact">
        <thead>
          <tr>
            <th>Usuario</th>
            <th>Correo electrónico</th>
            <th>Rol</th>
            <th>Estado</th>
            <th className="table-actions-header">Acciones</th>
          </tr>
        </thead>

        <tbody>
          {users && users.length > 0 ? (
            users.map((user) => (
              <tr key={user.id}>
                <td className="cell-strong">{user.username}</td>

                <td className="cell-muted">{user.email}</td>

                <td>
                  <select
                    className="select select-sm"
                    value={user.role}
                    onChange={(e) => changeRole(user.id, e.target.value)}
                  >
                    <option value="user">Invitado</option>
                    <option value="admin">Administrador</option>
                    <option value="tecnico">Técnico</option>
                    <option value="scanner">Operador escaneo</option>
                  </select>
                </td>

                <td>{getStatusBadge(user)}</td>

                <td>
                  <div className="table-actions">
                    {user.is_active === false ? (
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => reactivateUser(user.id)}
                      >
                        Reactivar
                      </button>
                    ) : (
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => deactivateUser(user.id)}
                      >
                        Desactivar
                      </button>
                    )}
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => resetPassword(user)}
                      disabled={user.is_active === false}
                    >
                      Reset password
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="table-empty">
                No se encontraron usuarios
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;
